import React from 'react';
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import '../styles/Sidebar.css';

const Sidebar = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  // Toggle function that adds/removes a class to the body
  const toggleMenu = () => {
    document.body.classList.toggle('mobile-menu-open');
  };

  // Close menu on navigation
  const closeMenu = () => {
    document.body.classList.remove('mobile-menu-open');
  };

  // Handle logout
  const handleLogout = () => {
    logout();
    closeMenu();
  };

  // Direct navigation to register.html
  const handleRegisterClick = () => {
    closeMenu();
    window.location.href = '/register.html';
  };

  return (
    <>
      {/* Mobile Header */}
      <header className="mobile-header">
        <button className="mobile-menu-button" onClick={toggleMenu} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div className="mobile-logo">
          <img src="/logo-emu-data.png" alt="EMU Data Logo" className="mobile-logo-img" />
          <span className="mobile-title">EMU Data</span>
        </div>
      </header>

      {/* Backdrop - appears when menu is open */}
      <div className="sidebar-backdrop" onClick={closeMenu}></div>

      {/* Sidebar Navigation */}
      <nav className="sidebar">
        <div className="sidebar-header">
          <img src="/logo-emu-data.png" alt="EMU Data Logo" className="logo-img" />
          <span>EMU Data</span>
        </div>
        <div className="sidebar-links">
          {isAuthenticated ? (
            <>
              {/* Links for authenticated users */}
              <NavLink to="/dashboard" onClick={closeMenu}>Dashboard</NavLink>
              <NavLink to="/water-meter" onClick={closeMenu}>Water Meter</NavLink>
              <NavLink to="/electricity-meter" onClick={closeMenu}>Electricity Meter</NavLink>
              <NavLink to="/alert-history" onClick={closeMenu}>Alert History</NavLink>
              <NavLink to="/billing" onClick={closeMenu}>Billing</NavLink>
              <NavLink to="/contact-us" onClick={closeMenu}>Contact Us</NavLink>
              <hr className="sidebar-divider" />
              <NavLink to="/profile" onClick={closeMenu}>My Profile</NavLink>
              <Link to="#" onClick={handleLogout} className="logout-link">Log Out</Link>
            </>
          ) : (
            <>
              {/* Links for unauthenticated users */}
              <NavLink to="/login" onClick={closeMenu}>Login</NavLink>
              <button
                onClick={handleRegisterClick}
                className="sidebar-link"
                style={{ 
                  display: 'block', 
                  width: '100%',
                  textAlign: 'left',
                  padding: '14px 20px',
                  color: 'white', 
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  fontSize: '1rem',
                  transition: 'all 0.2s ease',
                  borderLeft: '3px solid transparent'
                }}
              >Register</button>
              <NavLink to="/contact-us" onClick={closeMenu}>Contact Us</NavLink>
            </>
          )}
        </div>
      </nav>
    </>
  );
};

export default Sidebar;